import { useState } from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { CopyButton } from "@/components/ui/copy-button";

interface RevisedPromptAccordionProps {
  revisedPrompt: string;
  label?: string;
}

export const RevisedPromptAccordion = ({
  revisedPrompt,
  label = "Revised prompt",
}: RevisedPromptAccordionProps) => {
  const [value, setValue] = useState<string | undefined>(undefined);

  return (
    <div className="px-3 pb-1">
      <div className="overflow-hidden rounded-lg border border-gray-200">
        <Accordion type="single" collapsible value={value} onValueChange={setValue}>
          <AccordionItem value="revised-prompt" className="border-0">
            <AccordionTrigger className="px-4 py-3 text-left text-sm font-medium text-gray-700 hover:bg-gray-50/80 hover:no-underline data-[state=open]:border-b data-[state=open]:border-gray-200">
              {label}
            </AccordionTrigger>
            <AccordionContent className="p-0">
              <div className="group/prompt relative bg-gray-50/30 px-4 py-3">
                <p className="whitespace-pre-wrap text-sm leading-relaxed text-gray-700">
                  {revisedPrompt}
                </p>
                <div className="absolute right-4 top-3 z-10">
                  <CopyButton
                    text={revisedPrompt}
                    className="bg-white/70 opacity-0 transition-opacity duration-200 group-hover/prompt:opacity-100"
                    title="Copy prompt"
                  />
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};
